'use strict';

var angular = require('angular');

import '../app';

import './search-results/search-results';
import './category-filter/category-filter-component';
import './article-results/article-results';
import './media-coverage/media-coverage';
import './news-article-results/news-article-results';
import './news-category-filter/news-category-filter-component';